import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=28c650ae&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c650ae')) {
      api.createRecord('28c650ae', component.options)
    } else {
      api.reload('28c650ae', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=28c650ae&", function () {
      api.rerender('28c650ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B94e5pSPe1yx/JS/comp/FavElement.vue"
export default component.exports